<!--
 * @Author: kallen kallencao@tencent.com
 * @Date: 2025-08-12 21:26:44
 * @LastEditors: kallen kallencao@tencent.com
 * @LastEditTime: 2025-08-12 21:27:40
 * @FilePath: /note-admins/src/layout/components/ThemeSwitch.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-dropdown class="mr-3" trigger="click" @command="handleThemeChange">
    <span class="flex items-center text-gray-600 transition-colors cursor-pointer hover:text-blue-500">
      <el-icon class="text-lg">
        <Sunny v-if="currentTheme === 'light'" />
        <Moon v-else-if="currentTheme === 'dark'" />
        <Monitor v-else />
      </el-icon>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="light" :class="{ 'is-active': currentTheme === 'light' }">
          <el-icon class="mr-2"><Sunny /></el-icon>
          明亮模式
        </el-dropdown-item>
        <el-dropdown-item command="dark" :class="{ 'is-active': currentTheme === 'dark' }">
          <el-icon class="mr-2"><Moon /></el-icon>
          暗黑模式
        </el-dropdown-item>
        <el-dropdown-item command="auto" :class="{ 'is-active': currentTheme === 'auto' }">
          <el-icon class="mr-2"><Monitor /></el-icon>
          跟随系统
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElIcon } from 'element-plus';
import { Sunny, Moon, Monitor } from '@element-plus/icons-vue';

const appStore = useAppStore();

const currentTheme = computed(() => appStore.getTheme);

const handleThemeChange = (theme: 'light' | 'dark' | 'auto') => {
  appStore.setTheme(theme);
};
</script>

<style scoped>
.is-active {
  color: var(--el-color-primary);
  background-color: var(--el-color-primary-light-9);
}
</style>